import type { FC, MouseEvent, ReactNode } from 'react';

import { Button } from '@livechat/design-system-react-components';

import * as styles from './styles';

type Props = {
  href?: string;
  tabIndex?: number;
  dataTestid?: string;
  children: ReactNode;
  onClick?(e: MouseEvent): void;
};

export const FakeLink: FC<Props> = ({ href, tabIndex, dataTestid, children, onClick }) => (
  <Button
    kind="link-light"
    css={styles.link}
    href={href}
    onClick={onClick}
    tabIndex={tabIndex}
    data-testid={dataTestid}
  >
    {children}
  </Button>
);
